import React, { memo, useEffect } from "react"

import SectionsTitle from "../../../Common/new/SectionsTitle"

import Aos from "aos"
import { replaceUnderscoresWithSpaces } from "../../../utils/functions"
import OptimizedImage from "../../ImageShow/OptimizedImage"
import * as style from "./style.module.css"

const Overview = props => {
  const {
    overviewShowSection,
    CustomClass,
    overviewImage,
    overviewTag,
    overviewTitle,
    overviewContent,
  } = props

  useEffect(() => {
    Aos.init({
      once: true,
    })
  }, [])

  return (
    <>
      {overviewShowSection === "yes" && (
        <section className={`section_top_padding ${CustomClass}`}>
          <div className="container">
            <div
              data-aos="fade-up"
              data-aos-delay="50"
              className={style.overview_content_wrap}
            >
              <div className={style.overview_image_wrap}>
                <OptimizedImage
                  imageData={
                    overviewImage?.mediaItemUrl
                      ? overviewImage?.mediaItemUrl
                      : "/images/placeholder-image.jpg"
                  }
                  alt={overviewImage?.altText}
                />
              </div>
              <div className={style.overview_info_wrap}>
                <SectionsTitle
                  title={replaceUnderscoresWithSpaces(overviewTag)}
                  SubTitle={overviewTitle}
                  Content={overviewContent}
                  // classnames="overSection"
                  styleCss={{ display: "none" }}
                  classnames={style.overview_title}
                />
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(Overview)
